import { ApolloError, gql, useQuery } from '@apollo/client'
import { FeatureDisclaimerDataQuery, FeatureDisclaimerDataQueryVariables } from '../../types'

export const FEATURE_DISCLAIMER_DATA = gql`
  query FeatureDisclaimerData {
    featureDisclaimerData {
      title
      description
    }
  }
`
export default (): { data: FeatureDisclaimerDataQuery | undefined; error: ApolloError | undefined; loading: boolean } => {
  const { data, error, loading } = useQuery<FeatureDisclaimerDataQuery, FeatureDisclaimerDataQueryVariables>(FEATURE_DISCLAIMER_DATA)

  return { data, error, loading }
}
